var Helper;
(function(Helper) {
  var Controller = (function() {
    function Controller(disable) {
      this.def                      = "";
      this.isSending                = false;
      this.disableSendingOneAtATime = disable == undefined ? false : disable;
      var _this                     = this;
    }

    Controller.prototype.AjaxHelper = function(url, datatype, data, typeRequest, success, failed) {
      var _this = this;
      _this.def = $.Deferred();
      if (!_this.isSending) {
        if (!_this.disableSendingOneAtATime)
          _this.isSending = true;
        $.ajax(url, {
          cache    : false,
          type     : typeRequest,
          data     : data,
          dataType : datatype
        }).done(function(data) {
          success(data);
        }).fail(function(data) {
          failed(data);
        }).always(function() {
          _this.isSending = false;
          _this.def.resolve();
        });
      }
      return _this.def.promise();
    }

    Controller.prototype.DisableButtonUntilRequestFinished = function(doDisabled, jqueryElement) {
      if (doDisabled)
        $(jqueryElement).addClass('disableRequest');
      else
        $(jqueryElement).removeClass('disableRequest');
    }


    Controller.prototype.ResetDropdownToDefault = function(dropdownJqueryElement) {
      $(dropdownJqueryElement + ' option').prop('selected', function() {
        return this.defaultSelected;
      });
    }

    Controller.prototype.ResizeModalBox = function() {
      $('.modalBox').Height($(window).height());
    }

    Controller.prototype.FetchCityByZipCodeAndCountry = function(zipcode, country) {
      var _this = this;
      var def = $.Deferred();
      _this.AjaxHelper("/api/golfbox/FetchCityByZipCode?country=" + country + "&zipcode=" + zipcode, "json", "", "GET",
        function success(data) {
          if (data === "")
            def.reject();
          def.resolve(data);
        },
        function failed() {
          def.reject();
        });
      return def.promise();
    }

    Controller.prototype.SearchFilterSave = function(sfData) {
      var _this = this;
      var def = $.Deferred();
      _this.AjaxHelper("/SearchFilterSave", "json", sfData, "POST",
        function success(data) {
          def.resolve(data);
        },
        function failed(data) {
          def.reject(data);
        });
      return def.promise();
    }

    return Controller;
  })();
  Helper.Controller = Controller;
})(Helper || (Helper = {}));

var helperController = new Helper.Controller();